import {
  IClearTalkSheetAction,
  IGetTalkSheetAction,
  IGetTalkSheetFulfilledAction,
  IGetTalkSheetRejectedAction,
  ITalkSheetReduxState
} from "../../types";

const initialState: ITalkSheetReduxState = {
  completed: false,
  error: null,
  pending: false,
  rejected: false,
  sessionDateValues: null,
  talk: null,
  talkSheet: null,
  talkSheetValues: null
};

type Action = IGetTalkSheetAction | IGetTalkSheetFulfilledAction | IGetTalkSheetRejectedAction | IClearTalkSheetAction;

export default (state = initialState, action: Action): ITalkSheetReduxState => {
  switch (action.type) {
    case "GET_TALK_SHEET":
      return {
        ...state,
        completed: false,
        error: null,
        pending: true,
        rejected: false,
        sessionDateValues: null,
        talk: null,
        talkSheet: null,
        talkSheetValues: null
      };
    case "CLEAR_TALK_SHEET":
      return {
        ...state,
        completed: false,
        error: null,
        pending: false,
        rejected: false,
        sessionDateValues: null,
        talk: null,
        talkSheet: null,
        talkSheetValues: null
      };
    case "GET_TALK_SHEET_REJECTED":
      const { e } = action.payload;
      return {
        ...state,
        completed: true,
        error: e,
        pending: false,
        rejected: true,
        sessionDateValues: null,
        talk: null,
        talkSheet: null,
        talkSheetValues: null
      };
    case "GET_TALK_SHEET_FULFILLED":
      const { talk, talkSheet, talkSheetValues, sessionDateValues } = action.payload;
      return {
        ...state,
        completed: true,
        error: null,
        pending: false,
        rejected: false,
        sessionDateValues,
        talk,
        talkSheet,
        talkSheetValues
      };
    default:
      return {
        ...state
      };
  }
};
